import React from 'react';
import TableCell from '@material-ui/core/TableCell';

const ConversionTableCell = ({ children }) => (
  <TableCell padding="none" style={{ padding: '0', textAlign: 'center' }}>{children}</TableCell>
);

export default ConversionTableCell;



// WEBPACK FOOTER //
// ./src/components/calculator/conversion-table/ConversionTableCell.js